import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaInstagram, FaTruck, FaTwitch, FaVk, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div>
      <hr className="border-2 border-primary" />
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <p className="text-white">
                {t('footer.rights')} 
                <a href="/privacy" className="text-decoration-none text-white ms-1">
                  {t('footer.termsAndPrivacy')}
                </a>
              </p>
            </div>
            <div className="col-md-4 text-center">
              <div className="row">
                <div className="col-md-12">
                  <a 
                    href="https://truckersmp.com/vtc/48336-mileageriot" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    title={t('footer.socialLinks.tmp')} 
                    className="btn btn-icon btn-icon-tmp"
                  >
                    <FaTruck/>
                  </a>
                  <a 
                    href="https://vk.com/mileageriot" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    title={t('footer.socialLinks.vk')} 
                    className="btn btn-icon btn-icon-vk"
                  >
                    <FaVk/>
                  </a>
                  <a 
                    href="https://www.youtube.com/@mileageriot_official" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    title={t('footer.socialLinks.youtube')} 
                    className="btn btn-icon btn-icon-youtube"
                  >
                    <FaYoutube/>
                  </a>
                  <a 
                    href="https://twitch.tv/mileageriot_official" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    title={t('footer.socialLinks.twitch')} 
                    className="btn btn-icon btn-icon-twitch"
                  >
                    <FaTwitch/>
                  </a>
                  <a 
                    href="https://www.instagram.com/mileageriot_official/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    title={t('footer.socialLinks.instagram')} 
                    className="btn btn-icon btn-icon-instagram"
                  >
                    <FaInstagram/>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;